export default __webpack_public_path__ + "static/media/images/p1.245d0262.jpg";